export default "__VITE_ASSET__a12f5871__"